import * as types from "../mutationTypes"
import Auth from '../../services/auth'
import router from '../../routes/router'

let state = {
    accessToken: null,
    isLoggedIn: false,
    loading: true,
    error: null
}
const getters = {
    isAuthorized (state) {
        return state.isLoggedIn
    },
    token (state) {
        return state.accessToken
    },
    error (state) {
        return state.error
    }
}
const actions = {
    async login ({ commit, dispatch }, loginData) {
        try {
            commit(types.CLEAR_AUTHENTICATION)
            dispatch('user/clear', {}, { root: true })
            commit(types.REQUEST_AUTHENTICATION)
            let res = await Auth.login(loginData)
            if (res.status === 200) {
                commit(types.RECEIVE_AUTHENTICATION_SUCCESS, res.data)
                dispatch('user/setCurrentUser', res.data, { root: true })
                dispatch('user/loadAllUsers', {}, { root: true })
                dispatch('routes/getAll', {}, { root: true })
                if(res.data.roles[0] === 'Admin'){
                    // If admin, router.push map
                    await router.push('/map')
                } else {
                    // If not admin, router.push worker view
                    await router.push('/user/routes')
                }

            }
        } catch (error) {
            commit(types.RECEIVE_AUTHENTICATION_ERROR, {error: 'Error Logging In, Please Try Again.'})
        }
    },
    async sessionCheck ({ dispatch }) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            await Auth.sessionCheck()
        } catch (e) {
            dispatch('logout')
        }
            dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },
    clearAuth ({ commit }) {
        commit(types.CLEAR_AUTH_ERROR)
    },
    async logout ({ commit, dispatch }) {
        commit(types.CLEAR_AUTHENTICATION)
        dispatch('user/clear', {}, { root: true })
        await router.push('/')
    }
}
const mutations = {
    [types.REQUEST_AUTHENTICATION] (state) {
        state.accessToken = null
        state.isLoggedIn = false
        state.loading = true
        state.error = ''
    },
    [types.RECEIVE_AUTHENTICATION_SUCCESS] (state, data) {
        state.accessToken = data.accessToken
        state.isLoggedIn = true
        state.loading = false
        state.error = null
    },
    [types.RECEIVE_AUTHENTICATION_ERROR] (state, data) {
        state.accessToken = null
        state.isLoggedIn = false
        state.loading = false
        state.error = data.error
    },
    [types.CLEAR_AUTHENTICATION] (state) {
        state.accessToken = null
        state.isLoggedIn = false
        state.loading = false
        state.error = null
    },

    [types.CLEAR_AUTH_ERROR] (state) {
        state.error = null
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
